import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {
    setApplicationDetails, setApplicationRequirementDetails,
    setGeneralDetails,
    setLoginDetails,
    setPermissionDetails
} from "../../../actions/actions";
import logo from "../../../images/logo.png";
import { Link, useLocation , useNavigate} from "react-router-dom";

function Header(props) {
    const [userData] = useState(props.applicationLogin);
    const navigate = useNavigate();
    const handleLogout = () => {
        props.setOnLoginDetails("");
        props.setOnApplicationDetails("");
        props.setOnGeneralDetails("")
        props.setOnApplicationRequirementDetails([])
        navigate("/login");
    };

    return (
        <>
            <div className="header" id="printPageButton">

            <div className="header-left active mt-1">
                <Link to="/" className="logo logo-normal">
                    <img src={logo} style={{width: '60px', height: '60px'}} alt="Logo"/>
                </Link>
                <Link to="/" className="logo-small">
                    <img src={logo} style={{width: '60px', height: '55px'}}  alt="Logo"/>
                </Link>
                <Link to="/" className="dark-logo">
                    <img src={logo} style={{width: '60px', height: '60px'}}  alt="Logo"/>
                </Link>

                    <Link id="toggle_btn" href="#">
                        <i className="ti ti-menu-deep"></i>
                    </Link>
            </div>

                <a id="mobile_btn" className="mobile_btn" href="#sidebar">
                {/*<span className="bar-icon">*/}
                {/*    <span></span>*/}
                {/*    <span></span>*/}
                {/*    <span></span>*/}
                {/*</span>*/}
                </a>

                <div className="header-user">
                    <div className="nav user-menu">

                        <div className="nav-item nav-search-inputs me-auto">
                            <div className="top-nav-search">
                                <a href="javascript:void(0);" className="responsive-search">
                                    <i className="fa fa-search"></i>
                                </a>
                                <form action="#" className="dropdown">
                                    <div className="searchinputs" id="dropdownMenuClickable">
                                        {/*<input type="text" placeholder="Search"/>*/}
                                        {/*    <div className="search-addon">*/}
                                        {/*        <button type="submit"><i className="ti ti-command"></i></button>*/}
                                        {/*    </div>*/}
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="d-flex align-items-center">
                            <div className="pe-1">
                                <a href="#" id="dark-mode-toggle"
                                   className="dark-mode-toggle activate btn btn-outline-light bg-white btn-icon me-1">
                                    <i className="ti ti-moon"></i>
                                </a>
                                <a href="#" id="light-mode-toggle"
                                   className="dark-mode-toggle btn btn-outline-light bg-white btn-icon me-1">
                                    <i className="ti ti-brightness-up"></i>
                                </a>
                            </div>
                            <div className="dropdown ms-1">
                                <a href="javascript:void(0);" className="dropdown-toggle d-flex align-items-center"
                                   data-bs-toggle="dropdown">
								<span className="avatar avatar-md rounded">
									<img src={logo} alt="Img" className="img-fluid"/>
								</span>
                                </a>
                                <div className="dropdown-menu">
                                    <div className="d-block">
                                        <div className="d-flex align-items-center p-2">
										<span className="avatar avatar-md me-2 online avatar-rounded">
											<img src={logo} alt="img"/>
										</span>
                                            <div>
                                                <h6 className="">{`${userData.FirstName} ${userData.MiddleName} ${userData.Surname}`}</h6>
                                            </div>
                                        </div>
                                        <hr className="m-0"/>
                                                <a className="dropdown-item d-inline-flex align-items-center p-2" onClick={handleLogout} href=""><i
                                                    className="ti ti-login me-2"></i>Logout</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="dropdown mobile-user-menu">
                    <a href="javascript:void(0);" className="nav-link dropdown-toggle" data-bs-toggle="dropdown"
                       aria-expanded="false"><i className="fa fa-ellipsis-v"></i></a>
                    <div className="dropdown-menu dropdown-menu-end">
                        <a className="dropdown-item" href="" onClick={handleLogout}>Logout</a>
                    </div>
                </div>

            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnApplicationDetails: (p) => {
            dispatch(setApplicationDetails(p));
        },
        setOnGeneralDetails: (p) => {
            dispatch(setGeneralDetails(p));
        },
        setOnApplicationRequirementDetails: (p) => {
            dispatch(setApplicationRequirementDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
